var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.changePassword_title } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-4" },
                [
                  _c(
                    "b-col",
                    [
                      _c("form-card-wrapper", {
                        attrs: {
                          label: _vm.$t("common.idtfr"),
                          readOnlyValue: _vm.login,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.connectToGoogle
                ? _c(
                    "b-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "form-card-wrapper",
                            {
                              attrs: {
                                label: _vm.$t("common.orig_pwd"),
                                controlId: "originalPassword",
                                required: true,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm.currentPasswordType === "checkbox"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.originalPassword,
                                            expression: "originalPassword",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "originalPassword",
                                          placeholder:
                                            _vm.$t("common.orig_pwd"),
                                          "aria-required": true,
                                          "aria-describedby":
                                            _vm.originalPasswordError,
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.originalPassword
                                          )
                                            ? _vm._i(
                                                _vm.originalPassword,
                                                null
                                              ) > -1
                                            : _vm.originalPassword,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.originalPassword,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.originalPassword =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.originalPassword = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.originalPassword = $$c
                                            }
                                          },
                                        },
                                      })
                                    : _vm.currentPasswordType === "radio"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.originalPassword,
                                            expression: "originalPassword",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "originalPassword",
                                          placeholder:
                                            _vm.$t("common.orig_pwd"),
                                          "aria-required": true,
                                          "aria-describedby":
                                            _vm.originalPasswordError,
                                          type: "radio",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.originalPassword,
                                            null
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.originalPassword = null
                                          },
                                        },
                                      })
                                    : _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.originalPassword,
                                            expression: "originalPassword",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "originalPassword",
                                          placeholder:
                                            _vm.$t("common.orig_pwd"),
                                          "aria-required": true,
                                          "aria-describedby":
                                            _vm.originalPasswordError,
                                          type: _vm.currentPasswordType,
                                        },
                                        domProps: {
                                          value: _vm.originalPassword,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.originalPassword =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "password-toggle-btn ml-2",
                                      attrs: {
                                        type: "button",
                                        "aria-label":
                                          _vm.isCurrentPasswordFieldHidden
                                            ? _vm.$t("common.show_password")
                                            : _vm.$t("common.hide_password"),
                                      },
                                      on: {
                                        click: _vm.switchCurrentPasswordType,
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.switchCurrentPasswordType.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "space",
                                                32,
                                                $event.key,
                                                [" ", "Spacebar"]
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.switchCurrentPasswordType.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          _vm.isCurrentPasswordFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.connectToGoogle
                ? _c(
                    "b-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "form-card-wrapper",
                            {
                              attrs: {
                                label: _vm.$t("common.new_pwd"),
                                controlId: "newPassword",
                                required: true,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm.newPasswordType === "checkbox"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.newPassword,
                                            expression: "newPassword",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "newPassword",
                                          placeholder: _vm.$t("common.new_pwd"),
                                          "aria-required": true,
                                          "aria-describedby":
                                            _vm.newPasswordError,
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.newPassword
                                          )
                                            ? _vm._i(_vm.newPassword, null) > -1
                                            : _vm.newPassword,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.newPassword,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.newPassword = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.newPassword = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.newPassword = $$c
                                            }
                                          },
                                        },
                                      })
                                    : _vm.newPasswordType === "radio"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.newPassword,
                                            expression: "newPassword",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "newPassword",
                                          placeholder: _vm.$t("common.new_pwd"),
                                          "aria-required": true,
                                          "aria-describedby":
                                            _vm.newPasswordError,
                                          type: "radio",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.newPassword,
                                            null
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.newPassword = null
                                          },
                                        },
                                      })
                                    : _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.newPassword,
                                            expression: "newPassword",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "newPassword",
                                          placeholder: _vm.$t("common.new_pwd"),
                                          "aria-required": true,
                                          "aria-describedby":
                                            _vm.newPasswordError,
                                          type: _vm.newPasswordType,
                                        },
                                        domProps: { value: _vm.newPassword },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.newPassword =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "password-toggle-btn ml-2",
                                      attrs: {
                                        type: "button",
                                        "aria-label":
                                          _vm.isNewPasswordFieldHidden
                                            ? _vm.$t("common.show_password")
                                            : _vm.$t("common.hide_password"),
                                      },
                                      on: {
                                        click: _vm.switchNewPasswordType,
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.switchNewPasswordType.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "space",
                                                32,
                                                $event.key,
                                                [" ", "Spacebar"]
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.switchNewPasswordType.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          _vm.isNewPasswordFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-4" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "form-card-wrapper",
                        {
                          attrs: {
                            label: _vm.$t("common.conf_pwd"),
                            controlId: "confirmNewPassword",
                            required: true,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _vm.confirmNewPasswordType === "checkbox"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmNewPassword,
                                        expression: "confirmNewPassword",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "confirmNewPassword",
                                      placeholder: _vm.$t("common.conf_pwd"),
                                      "aria-required": true,
                                      "aria-describedby":
                                        _vm.confirmPasswordError,
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.confirmNewPassword
                                      )
                                        ? _vm._i(_vm.confirmNewPassword, null) >
                                          -1
                                        : _vm.confirmNewPassword,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.confirmNewPassword,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.confirmNewPassword =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.confirmNewPassword = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.confirmNewPassword = $$c
                                        }
                                      },
                                    },
                                  })
                                : _vm.confirmNewPasswordType === "radio"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmNewPassword,
                                        expression: "confirmNewPassword",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "confirmNewPassword",
                                      placeholder: _vm.$t("common.conf_pwd"),
                                      "aria-required": true,
                                      "aria-describedby":
                                        _vm.confirmPasswordError,
                                      type: "radio",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.confirmNewPassword,
                                        null
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.confirmNewPassword = null
                                      },
                                    },
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmNewPassword,
                                        expression: "confirmNewPassword",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "confirmNewPassword",
                                      placeholder: _vm.$t("common.conf_pwd"),
                                      "aria-required": true,
                                      "aria-describedby":
                                        _vm.confirmPasswordError,
                                      type: _vm.confirmNewPasswordType,
                                    },
                                    domProps: { value: _vm.confirmNewPassword },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.confirmNewPassword =
                                          $event.target.value
                                      },
                                    },
                                  }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "password-toggle-btn ml-2",
                                  attrs: {
                                    type: "button",
                                    "aria-label":
                                      _vm.isConfirmNewPasswordFieldHidden
                                        ? _vm.$t("common.show_password")
                                        : _vm.$t("common.hide_password"),
                                  },
                                  on: {
                                    click: _vm.switchConfirmNewPasswordType,
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.switchConfirmNewPasswordType.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.switchConfirmNewPasswordType.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      _vm.isConfirmNewPasswordFieldHidden
                                        ? "fa-duotone fa-eye"
                                        : "fa-duotone fa-eye-slash",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.sve"),
              icon: "fa-light fa-floppy-disk",
              variant: "primary",
              title: _vm.changePassword_Validatechanges,
            },
            on: { click: _vm.changePassword },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }